export const FX_PAIR_FIXING_TYPE_ITEMS = [
  { id: 'MID', displayValue: 'Mid' },
  { id: 'BID', displayValue: 'Bid' },
  { id: 'ASK', displayValue: 'Ask' },
];
